import React, { useState, useEffect, useMemo } from 'react'
import { Bubble, Icon, Switch } from 'tea-component'
import { useLocal } from '@/pages/dashboard/utils/customHook';
import Select from '@/pages/dashboard/components/Select';
import "./index.scss";
import { formatMessage } from 'umi';


interface Props {
  value?: boolean
  defaultValue?: boolean
  onChange?: (flag: boolean) => any
  currentAlignedBy?: any;
  setCurrentAlignedBy?: any;
  alignedByList?: any;
}

const TimePickerSwitch = (props: Props) => {
  const {
    value,
    defaultValue,
    onChange,
    currentAlignedBy,
    setCurrentAlignedBy,
    alignedByList
  } = props
  const { isEN, locale, getLocalText } = useLocal();
  const [flag, setFlag] = useState<boolean>(defaultValue ?? false)

  const handleChange = (flag: any) => {
    setFlag(flag)
    onChange?.(flag)
  }

  useEffect(() => {
    setFlag(value ?? false)
  }, [value])

  return (
    <div className="selectContext-flex time-picker-container">
      <span className="selectContext-flex-text">{getLocalText('competitor_time_switch_text')}</span> 
      <Bubble dark content={getLocalText('competitor_time_switch_desc')}>
        <div className="selectContext-flex-icon">i</div>
      </Bubble>
      <Switch value={flag} className="selectContext-flex-switch" onChange={handleChange} />

      {flag && alignedByList && 
        <div className='type-selector'>
          <Select
            label={''}
            className=''
            value={currentAlignedBy}
            defaultValue={currentAlignedBy}
            options={alignedByList}
            onChange={(value) => {
              setCurrentAlignedBy(value)
            }}
            boxStyle={{ width: '198px' }}
            buttonContentClassName={'type-selector-title'}
          />
        </div>
      }

    </div>
  )
}

export default TimePickerSwitch